import angular from 'angular';
import ImageDetail from './imageDetail/imageDetail';
import ConfirmDialog from './confirmDialog/confirmDialog';
import ReportImages from './reportImages/reportImages';
import ReportMap from './reportMap/reportMap';
import FloraService from '../services/floraService/flora';
import ModelFactory from './factories/modelFactory/model';
import DaynamicModel from './directive/dynamicModel/dynamicModel';
import IsNumericArray from './directive/isNumericArray/isNumericArray';
import LanguageFactory from './factories/languageFactory/language';
import DotsFilter from './filters/dotsFilter/dots';
import NoHTMLFilter from './filters/noHTML/noHTML';
import CamelToKebab from './filters/camelToKebabService/camelToKebab';
import SnakeToSpace from './filters/snakeToSpaceService/snakeToSpace';
import ResourceService from '../services/resourceService/resource'
import UserService from '../services/userService/user';
import AuthService from '../services/authService/auth';
import InformationService from '../services/informationService/information';
import GeojsonBuilderService from '../services/geojsonBuilder/geojsonBuilder';
import UtilService from '../services/utilService/util';

let commonModule = angular.module('app.common', [
    ImageDetail,
    ConfirmDialog,
    FloraService,
    DotsFilter,
    NoHTMLFilter,
    CamelToKebab,
    SnakeToSpace,
    ModelFactory,
    LanguageFactory,
    DaynamicModel,
    IsNumericArray,
    ResourceService,
    UserService,
    AuthService,
    InformationService,
    GeojsonBuilderService,
    UtilService,
    ReportImages,
    ReportMap
])

    .name;

export default commonModule;



// WEBPACK FOOTER //
// ./client/app/common/common.js